<template>
  <div v-text="(percent*100)+'%'" class="percent"></div>
  <div class="float-ball-area">
    <div ref="ball" class="ball"></div>
    <div ref="title" class="title" v-text="techName"></div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";

export default {
  name: "FloatTechBallView",
  props: {
    percent: {
      type: Number,
      default: 1,
    },
    techName:{
      type: String,
      default: "",
    }
  },
  setup(props) {
    let ball = ref(null);
    let title = ref(null);
    onMounted(() => {
      let length = 126 * props.percent;
      let textSize = 32 * props.percent;
      ball.value.style.width = length + "px";
      ball.value.style.height = length + "px";
      ball.value.style.left = ((126 - length) / 2) + "px";
      title.value.style.fontSize = textSize + "px";
      title.value.style.top = ((length - textSize * 1.4) / 2) + "px";
    });
    return {
      ball,
      title,
    };
  }
};
</script>

<style scoped>

.float-ball-area {
  width: 126px;
  height: 126px;
  position: relative;
}

.ball {
  background: linear-gradient(90deg, #62CAFB 0%, #478FFC 100%);
  border-radius: 50%;
  position: absolute;
}

.title {
  color: white;
  font-weight: 600;
  position: absolute;
  width: 100%;
  text-align: center;
}

.percent {
  font-size: 30px;
  color: white;
  width: 126px;
  text-align: center;
}

</style>
